export default class Title {
    timeline = new gsap.timeline();
    flipTriggers = []
    constructor({ el }) {
        this.el = el

        this.splitAnimated = el.classList.contains("split-animated")
        this.splitAnimatedHero = el.classList.contains("split-animated-hero")

        this.handleResize();
        this.boundResize = this.handleResize.bind(this);
        ScrollTrigger.addEventListener("refresh", this.boundResize)
        window.addEventListener("resize", this.boundResize);
    }

    handleResize() {
        this.split?.revert();
        this.flipTriggers.forEach(trigger => trigger.kill());
        this.flipTriggers = []
        
        if (this.splitAnimated) {
            if (window.innerWidth <= 768) {
                this.el.querySelectorAll('br').forEach(br => br.remove());
            }

            this.split = new SplitText(this.el, {
                type: "lines, words",
                linesClass: "flex-line",
                wordsClass: "flex-word"
            });
            gsap.set(this.split.lines, { 
                display: "flex", 
                justifyContent: "center",
                width: "100%",
                gap: "0.275em" 
            });

            gsap.set(this.split.words, { 
                display: "inline-flex",
                position: "relative",
            });


            this.split.lines.forEach((line, index) => {
                const lineWords = line.querySelectorAll(".flex-word");
                
                const state = Flip.getState(lineWords);

                gsap.set(line, { justifyContent: "space-between" });

               const trigger = Flip.to(state, {
                    duration: 1,
                    ease: "power3.inOut",
                    stagger: 0.05,
                    scrollTrigger: {
                        trigger: line,
                        start: "top 80%",
                        end: "top 50%",
                        scrub: true,
                        markers: false
                    }
                });

                this.flipTriggers.push(trigger)
            });
        } else if (this.splitAnimatedHero && window.innerWidth > 768) {

            this.split = new SplitText(this.el, {
                type: "lines, words",
                linesClass: "flex-line",
                wordsClass: "flex-word"
            });
            gsap.set(this.split.lines, { 
                display: "flex", 
                justifyContent: "center",
                width: "100%",
                gap: "0.275em" 
            });

            gsap.set(this.split.words, { 
                display: "inline-flex",
                position: "relative",
            });


            this.split.lines.forEach((line, index) => {
                const lineWords = line.querySelectorAll(".flex-word");
                
                const state = Flip.getState(lineWords);

                gsap.set(line, { justifyContent: "space-between" });

               const trigger = Flip.to(state, {
                    duration: 1,
                    ease: "power3.inOut",
                    delay: 0.05 * index
                });

                this.flipTriggers.push(trigger)
            });
        }

    }

    dispose() {
        ScrollTrigger.removeEventListener("refresh", this.boundResize)
        window.removeEventListener("resize", this.boundResize);

    }
}